
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12059',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12059",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.459",
  "dashboard-client-types": "static-1.339",
  "data-fetching-client": "static-1.9618",
  "foundations-components": "static-1.7815",
  "foundations-components-legacy": "static-1.840",
  "foundations-theming": "static-1.4359",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.80",
  "head-dlb": "static-1.4938",
  "hs-test-utils": "static-1.7960",
  "hub-http-shared-msw-handlers": "static-1.9828",
  "hubspot-dlb": "static-2.1832",
  "hubspot-url-utils": "static-1.4049",
  "HubStyleTokens": "static-2.11404",
  "I18n": "static-7.1610",
  "jasmine-runner": "static-1.6414",
  "marketplace-storefront-base": "static-1.12120",
  "quartz": "static-1.6944",
  "react-dlb": "static-1.77",
  "react-rhumb": "static-1.16607",
  "reactive-variable-buffer-atom": "static-1.2804",
  "reporting-testing-lib": "static-1.9195",
  "settings-ui-lib": "static-1.12466",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7025",
  "ui-addon-i18n": "static-1.11095",
  "ui-addon-react-router-dom": "static-1.9490",
  "unified-auth": "static-1.416",
  "unified-auth-core-lib": "static-1.697",
  "usage-tracker": "static-1.7281",
  "usage-tracker-core": "static-1.7131",
  "customer-data-property-utils": "static-1.8028",
  "hub-http": "static-1.6165",
  "integrations-lib": "static-1.15929",
  "marketplace-ui-common": "static-1.19488",
  "property-management-iframe": "static-1.12965",
  "quartz-config": "static-1.722",
  "quartz-core": "static-1.6163",
  "quartz-routing": "static-1.374",
  "quick-fetch": "static-1.3870",
  "react": "static-7.184",
  "rpc-client-utils": "static-1.4591",
  "ts-schema": "static-1.4031",
  "ui-universal-auth": "static-1.8902",
  "UIComponents": "static-3.8351",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.428",
  "hs-promise-rejection-tracking": "static-1.5489",
  "PortalIdParser": "static-2.388",
  "raven": "static-3.5829",
  "raven-hubspot": "static-1.6136",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.77",
  "metrics-js": "static-1.9542",
  "react-redux": "static-7.70",
  "redux": "static-4.16",
  "styled-components": "static-2.88",
  "bend-plugin-trellis-migration": "static-1.3357",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3221",
  "quartz-webpack": "static-1.3168",
  "bend-plugin-quartz-routing": "static-1.22",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4084",
  "floating-ui": "static-1.54",
  "foundations-assets": "static-1.4797",
  "foundations-theming-specialty": "static-1.2075",
  "framer-motion": "static-1.70",
  "hs-story-utils": "static-1.9373",
  "react-aria": "static-1.64",
  "react-create-root-preference": "static-1.9",
  "react-select-plus": "static-1.103",
  "react-utils": "static-2.5297",
  "react-virtualized": "static-2.97",
  "StyleGuideUI": "static-3.486",
  "tanstack-table": "static-1.53",
  "trellis-assets": "static-1.1636",
  "ui-fonts": "static-1.666",
  "ui-images": "static-2.1138",
  "bend-plugin-foundations-theming": "static-1.2842",
  "foundations-theming-base": "static-1.3344",
  "stylex": "static-1.31",
  "HeadJS": "static-2.740",
  "hs-test-utils-bend-plugin": "static-1.3071",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.81",
  "jasmine": "static-4.4269",
  "ai-components-ui-library": "static-1.8785",
  "ai-rendering-library": "static-1.9884",
  "chirp-fetch": "static-1.1830",
  "connections-embed-lib": "static-1.890",
  "copilot-toolkit": "static-1.10962",
  "feedback-loader": "static-1.29191",
  "laboratory-lib": "static-3.7103",
  "marketplace-embed": "static-1.21910",
  "marketplace-ui-details": "static-1.9384",
  "marketplace-ui-reviews": "static-1.19444",
  "marketplace-ui-tracking": "static-1.13659",
  "sanitize-text": "static-1.8087",
  "ui-addon-video-player": "static-1.8642",
  "usage-tracker-multi": "static-1.5695",
  "usage-tracker-session-replay": "static-1.4967",
  "wootric-nps": "static-1.6927",
  "quartz-head": "static-1.609",
  "apollo-link-hub-http": "static-2.4593",
  "immer": "static-1.33",
  "immerable": "static-1.4098",
  "highcharts": "static-8.102",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2458",
  "reporting-data": "static-1.67262",
  "cssUtils": "static-1.778",
  "flux-actions": "static-1.329",
  "HubStyle": "static-2.11712",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10155",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10316",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7271",
  "icons": "static-2.643",
  "marketplace-ui-apps-core": "static-1.18021",
  "storybook-react": "static-1.31",
  "trellis-story-utils": "static-1.4460",
  "foundations-components-test-utils": "static-1.5298",
  "quartz-i18n": "static-1.619",
  "react-input-autosize": "static-2.17",
  "google-sheets-integration-lib": "static-1.65",
  "microsoft-drive-integration-lib": "static-1.172",
  "fsm": "static-1.3677",
  "customer-data-objects": "static-1.7605",
  "property-translator": "static-1.5347",
  "hs-locale-management": "static-1.37",
  "frontend-preferences-client": "static-1.7871",
  "hs-promise-utils": "static-1.5538",
  "hubspot-apollo-client": "static-1.4821",
  "integrations-error-boundary-lib": "static-1.13344",
  "integrations-tracking-lib": "static-1.5541",
  "native-integrations-shared-strings": "static-1.7728",
  "reselect": "static-2.16",
  "sanitize": "static-1.4417",
  "superstore": "static-1.4711",
  "ui-shepherd-react": "static-3.10093",
  "ai-settings-ui-library": "static-1.7790",
  "hub-http-janus": "static-1.826",
  "hubspotter-http": "static-1.4605",
  "immutable-less": "static-1.4594",
  "marketplace-ui-client-types": "static-1.16895",
  "nav-meta": "static-1.29459",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10190",
  "ui-addon-upgrades": "static-9.17902",
  "inbound-db-properties-service-client": "static-1.3794",
  "property-management-common": "static-1.5253",
  "ui-addon-iframeable": "static-1.8997",
  "dispatcher": "static-1.135",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.514",
  "module-federation": "static-1.21",
  "quartz-auth": "static-1.619",
  "quartz-test": "static-1.619",
  "quartz-tracking": "static-1.323",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.3123",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21008",
  "ContentUtils": "static-1.68187",
  "customer-data-objects-ui-components": "static-1.12967",
  "sassPrefix": "static-1.154",
  "avatar-components": "static-1.2440",
  "customer-data-filters-ui": "static-1.39546",
  "customer-data-reference-ui-components": "static-1.13100",
  "embedded-academy-lib": "static-1.14129",
  "ExportDialog": "static-6.10337",
  "highlight.js": "static-1.77",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.41139",
  "reporting-snowflake": "static-1.55880",
  "reporting-ui-components": "static-2.64533",
  "reporting-visualizations": "static-1.59338",
  "ui-addon-teams": "static-1.21471",
  "magpie-lib": "static-1.5523",
  "navigation-components": "static-1.17822",
  "magpie-types": "static-1.4983",
  "simple-logging-lib": "static-1.2993",
  "ai-studio-lib": "static-1.11428",
  "app-governance-lib": "static-1.1358",
  "developer-experience-shared-components": "static-1.10452",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7939",
  "ui-product-approvals": "static-1.27973",
  "ui-tool-access": "static-1.10093",
  "usage-based-billing-components-lib": "static-1.8578",
  "usage-tracker-anonymous": "static-1.5698",
  "usage-tracker-public": "static-1.7092",
  "amplitude-session-replay-browser": "static-1.58",
  "inbound-db-meta-service-client": "static-1.3544",
  "persist-promise": "static-1.3652",
  "reference-resolvers": "static-1.8114",
  "ui-extensibility-client-types": "static-1.3875",
  "hubspot-apollo-cache": "static-1.280",
  "universal-page-editor-lib": "static-1.2956",
  "final-form": "static-1.68",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2608",
  "merchandise-lib": "static-1.262",
  "atom": "static-1.5016",
  "purchase-motions-components": "static-1.5778",
  "salesImages": "static-1.524",
  "batch-promise": "static-1.1495",
  "crm-component-utils": "static-1.38924",
  "crm-properties-common-lib": "static-1.5820",
  "customer-data-properties": "static-1.51345",
  "framework-data-schema-resolvers": "static-1.6822",
  "property-value-citations": "static-1.1959",
  "reference-resolvers-lite": "static-1.8038",
  "navigation-messaging": "static-1.7149",
  "hubspotter-http-shared-msw-handlers": "static-1.9826",
  "cms-field-types": "static-1.4755",
  "content-icons-ui": "static-1.2211",
  "customer-data-ui-utilities": "static-1.9770",
  "conversations-skeleton-state": "static-1.7193",
  "crm-message-bus": "static-1.42828",
  "customer-data-filters-ui-msw-helpers": "static-1.21981",
  "FormUrlGenerator": "static-2.4664",
  "framework-builder-read-service-client": "static-1.3963",
  "framework-data-schema-quick-fetch": "static-1.6727",
  "multi-account-reference-resolvers": "static-1.923",
  "onboarding-tours": "static-1.16485",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13499",
  "academy-common-lib": "static-1.13589",
  "content-assistance-lib": "static-1.7661",
  "dashboard-lib": "static-1.81291",
  "file-manager-components": "static-1.23451",
  "getting-started-shared-tasks": "static-1.18336",
  "hubspot-prosemirror": "static-1.18065",
  "hubspot-prosemirror-plugins": "static-1.18057",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19727",
  "share-with-third-party-component-lib": "static-1.8641",
  "ui-addon-draggable": "static-3.4714",
  "ui-asset-management-lib": "static-1.10946",
  "ui-business-units-lib": "static-1.8990",
  "user-context": "static-1.5045",
  "growth-payments-core": "static-1.25197",
  "reporting-plugins": "static-1.10196",
  "reporting-reports": "static-1.66940",
  "idb-keyval": "static-1.42",
  "reactive-lib": "static-1.665",
  "nest": "static-1.168",
  "codemirror": "static-5.93",
  "react-codemirror": "static-1.10568",
  "framework-listing-lib": "static-2.28514",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30560",
  "apps-service-types": "static-1.3821",
  "oauth-service-types": "static-1.4193",
  "onboarding-scopes": "static-1.6407",
  "onboarding-tours-client": "static-1.4699",
  "platform-infra-nav-components": "static-1.7625",
  "subscription-experience-data-types": "static-1.14830",
  "crm-record-cards-service-types": "static-1.3564",
  "location-customization-utils-lib": "static-1.9070",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.5781",
  "signup-constants": "static-1.18737",
  "signup-ui-url-generator": "static-2.7981",
  "trials-service-types": "static-1.3847",
  "card-properties-lib": "static-1.43998",
  "commerce-subscription-lib": "static-1.36936",
  "crm-actions": "static-1.6261",
  "crm-cards-sdk": "static-1.43407",
  "customer-data-properties-shared-msw-handlers": "static-1.9155",
  "customer-data-tracking": "static-1.6830",
  "hs-resources": "static-1.86",
  "pulse": "static-1.497",
  "calling-global-api": "static-1.64304",
  "calling-internal-common": "static-1.31245",
  "calling-lifecycle-internal": "static-1.65686",
  "calling-lifecycle-messages": "static-1.57980",
  "commerce-products-lib": "static-1.9310",
  "conditional-properties-service-client": "static-1.3750",
  "crm-links": "static-1.6223",
  "external-options-client-types": "static-1.4112",
  "google-libphonenumber": "static-1.36",
  "inbounddb-objects-service-types": "static-1.4177",
  "meetings-icalendar-utils-lib": "static-1.575",
  "multi-currency-client-types": "static-1.3645",
  "object-builder-ui-client": "static-1.48543",
  "pipeline-validation-client-types": "static-1.3919",
  "smart-property-lib": "static-1.6651",
  "tiered-pricing": "static-1.1083",
  "ui-addon-form-validation": "static-1.10933",
  "crm-pipelines-api-client-types": "static-1.4096",
  "react-dnd-compat": "static-1.4564",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5334",
  "growth-onboarding-confetti": "static-1.3012",
  "growth-onboarding-next-action-utils": "static-1.1745",
  "onboarding-tours-utils": "static-1.551",
  "ui-shepherd-tracker": "static-1.7474",
  "academy-service-client": "static-1.3626",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.38950",
  "FileManagerLib": "static-1.39091",
  "zustand": "static-1.72",
  "ui-coaching-tips": "static-1.28381",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8319",
  "video-components-external": "static-1.11081",
  "video-data-lib": "static-1.34739",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8479",
  "payment-link-components": "static-1.23367",
  "ui-addon-emoji-picker": "static-1.9832",
  "EmailSignatureEditor": "static-1.24246",
  "viral-links-lib": "static-1.6996",
  "data-token-picker": "static-1.16299",
  "react-flip-move": "static-1.68",
  "nested-table": "static-1.170",
  "timezone-utils": "static-2.5188",
  "getting-started-shared-tasks-store": "static-1.17454",
  "campaign-roi-lib": "static-1.8901",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-associations": "static-1.7270",
  "customer-data-views-management": "static-1.25336",
  "framework-data-table": "static-2.11783",
  "marketing-platform-lib": "static-1.6795",
  "nudge-client-utils": "static-1.2430",
  "nudge-custom-ui-functions": "static-1.910",
  "app-users-service-client": "static-1.5528",
  "app-users-service-types": "static-1.4936",
  "mini-checkout-client": "static-1.26655",
  "onboarding-utils": "static-1.5295",
  "permissions-shared-i18n-strings-fe": "static-1.2018",
  "ui-coaching-tips-shared-config": "static-1.28366",
  "edison-service-client-types": "static-1.330",
  "crm_data": "static-4.91768",
  "customer-data-sidebar": "static-2.45835",
  "enrichment-properties-lib": "static-1.15769",
  "commerce-billing-lib": "static-1.18895",
  "commerce-shared-components-lib": "static-1.18355",
  "commerce-tools-ui-lib": "static-1.10217",
  "crm-fe-perf": "static-1.22848",
  "directed-graph": "static-1.880",
  "event-emitter": "static-1.893",
  "fast-json-patch": "static-1.61",
  "calling-error-reporting": "static-1.31251",
  "shared-worker-versioning": "static-1.10981",
  "calling-usage-tracker": "static-1.6486",
  "voice-sms-access-library": "static-1.749",
  "commerce-permissions": "static-1.709",
  "products-iframe-lib": "static-1.7759",
  "products-ui-components-shared-msw-handlers": "static-1.10210",
  "data-agent-kit": "static-1.101",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9911",
  "policy-lib": "static-1.6716",
  "react-tinymce": "static-1.55075",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9974",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54201",
  "tinymce-plugins": "static-1.57315",
  "tinymce-themes": "static-1.56171",
  "onboarding-data-sync-lib": "static-1.1859",
  "growth-onboarding-next-action-components": "static-1.1773",
  "user-context-client": "static-1.4554",
  "audio-components": "static-1.5826",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.36602",
  "urlinator": "static-1.4476",
  "video-components": "static-1.13084",
  "video-embed": "static-1.35573",
  "growth-onboarding-feedback-components": "static-1.6528",
  "content-media-composition-data-lib": "static-1.12055",
  "content-media-compositions": "static-2.16062",
  "media-bridge-lib": "static-1.18823",
  "commerce-tours-lib": "static-1.5985",
  "growth-onboarding-reliability": "static-1.5026",
  "sales-checkout-service-client": "static-1.3583",
  "draft-convert": "static-2.71",
  "draft-extend": "static-3.73",
  "draft-js": "static-5.76",
  "draft-plugins": "static-2.21567",
  "sales-email-signature-service-client": "static-1.3786",
  "ts-utils-lib": "static-1.116",
  "crm-export-dialog": "static-1.6242",
  "crm-index-associations-lib": "static-1.6383",
  "react-beautiful-dnd": "static-1.13",
  "deal-intel-decorators": "static-1.1807",
  "tanstack-virtual": "static-1.28",
  "nudge-custom-function-registry": "static-1.2187",
  "nudge-renderer-utils": "static-1.2506",
  "whisper-core-api": "static-1.6439",
  "InboxConnectUtils": "static-4.14638",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5372",
  "settings-content-modals": "static-1.45910",
  "crm_universal": "static-1.21902",
  "customer-data-email": "static-1.17929",
  "card-payment-highlight-lib": "static-1.36999",
  "card-subscription-highlight-lib": "static-1.39359",
  "commerce-contract-lib": "static-1.11807",
  "invoices-highlight-card-lib": "static-1.54518",
  "orders-highlight-card-lib": "static-1.21294",
  "products-highlight-card-lib": "static-1.17594",
  "quotes-highlight-card-lib": "static-1.71780",
  "crm-source-interpretation-lib": "static-1.5280",
  "utility-belt": "static-1.2482",
  "payments-enrollment-embed-lib": "static-1.22488",
  "stripe-embedded-components": "static-1.7397",
  "customer-data-rte": "static-1.32840",
  "cv-backend-services": "static-1.1551",
  "growth-onboarding-empty-states": "static-1.5608",
  "payments-post-enroll-local-storage-lib": "static-1.5054",
  "qrcode-generator": "static-1.67",
  "quotes-client-types": "static-1.37870",
  "calling-orchestration-schema": "static-1.35526",
  "sales-views-client-types": "static-1.4208",
  "hub-http-contrib": "static-1.2984",
  "interframe": "static-3.4705",
  "tinymce-data": "static-1.40286",
  "ui-addon-sales-email": "static-1.5154",
  "layout-dnd-components": "static-1.12329",
  "layout-dnd-utils": "static-1.11304",
  "ui-brand-identity-lib": "static-1.14977",
  "NamespacedHubStyle": "static-2.9016",
  "social-insights-client-types": "static-1.21921",
  "outpost": "static-1.4134",
  "js-cookie": "static-1.18",
  "deal-intel-utils": "static-1.1811",
  "checkout-sdk": "static-3.23498",
  "checkout-service-types": "static-1.3780",
  "company-details-components": "static-1.6140",
  "payment-method-components": "static-1.6854",
  "pricing-pages-ui-components": "static-1.13578",
  "quote-checkout-service-types": "static-1.3422",
  "upgrade-catalog-service-types": "static-1.3468",
  "access-control-lib": "static-1.10382",
  "EmailComponents": "static-1.54603",
  "EmailData": "static-1.53280",
  "redux-less": "static-2.9428",
  "sequences-lib": "static-1.7937",
  "ui-gdpr-components": "static-1.10290",
  "products-ui-components": "static-1.39829",
  "quotes-ui-lib": "static-1.80501",
  "accounting-integrations-ui-components": "static-1.6966",
  "invoices-ui-lib": "static-1.54534",
  "commerce-products-api": "static-1.2202",
  "invoices-iframe-lib": "static-1.56592",
  "quotes-modal-lib": "static-1.102458",
  "stripe-connect-js": "static-1.67",
  "draft-content-plugins": "static-1.28108",
  "ContentData": "static-1.68262",
  "layout-data-lib": "static-1.9629",
  "hub-http-rxjs": "static-1.792",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3876",
  "billing-payments-client-types": "static-1.3934",
  "react-performance-metrics-lib": "static-1.502",
  "account-and-billing-fintech-outages": "static-3.18484",
  "pricing-pages-api": "static-1.13443",
  "ContentComponents": "static-2.71143",
  "marketing-contacts-lib": "static-1.9746",
  "marketing-email-service-types": "static-1.1877",
  "messaging-editing-lib": "static-1.46090",
  "messaging-usage-based-billing-components-lib": "static-1.952",
  "automation-ui-source-apps": "static-1.18697",
  "automation-ui-types": "static-1.19615",
  "messaging-types-lib": "static-1.45827",
  "onboarding-settings-client": "static-1.4446",
  "sequences-client-types-lib": "static-1.7794",
  "commerce-tax-lib": "static-1.466",
  "property-description-translator": "static-1.3792",
  "SalesContentIndexUI": "static-3.9156",
  "commerce-analytics-service-client": "static-1.3571",
  "totals-ui-components": "static-1.23417",
  "advanced-menus-core": "static-1.15035",
  "advanced-menus-lib": "static-1.11989",
  "ui-memberships-settings-lib": "static-1.33886",
  "segments-query-core": "static-1.1358",
  "demographics-service-types": "static-1.1596",
  "eligibility-engine-service-types": "static-1.3128",
  "automation-ui-ubb": "static-1.5531",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7284",
  "data-token-views": "static-1.16280",
  "forms-utils-lib": "static-1.12467",
  "payments-embed-points-lib": "static-1.12909",
  "simple-menus-core": "static-1.15034",
  "simple-menus-lib": "static-1.16551",
  "ui-addon-draggable-compat": "static-2.4199",
  "videoconference-integration-components": "static-1.6734",
  "automation-applications-service-types": "static-1.3457",
  "automation-platform-service-types": "static-1.2562",
  "ContentEditorUI": "static-2.76947",
  "short-messages-app-service-client": "static-1.3924",
  "web-interactives-components": "static-1.13657",
  "web-interactives-data": "static-1.13658",
  "messaging-shared-utils-lib": "static-1.401",
  "messaging-user-info-utils-lib": "static-1.571",
  "email-portal-health-service-types": "static-1.920",
  "FireAlarmUi": "static-1.4467",
  "sales-templates-service-types-lib": "static-1.4121",
  "commerce-totals-service-types": "static-1.3772",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21551",
  "automation-ui-usage-tracking": "static-1.21014",
  "data-studio-ubb": "static-1.2543",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.26857",
  "collaboration-sidebar": "static-1.57621",
  "content-management-data-lib": "static-1.5309",
  "copilot-plugins": "static-1.10935",
  "cta-picker": "static-1.36244",
  "customer-agent-discovery-components-lib": "static-1.2913",
  "editor-components": "static-1.13149",
  "editor-iframe-lib": "static-1.8320",
  "error-messaging-js": "static-1.5136",
  "FormsCommonComponents": "static-1.85677",
  "pictos": "static-7.183",
  "react-transition-group": "static-2.63",
  "redux-request-state": "static-1.10591",
  "SharedLegalStrings": "static-1.1689",
  "smart-content-core": "static-1.42273",
  "smart-content-lib": "static-1.42926",
  "social-composer-lib": "static-1.58834",
  "structured-content-lib": "static-1.25032",
  "theme-previewer-lib": "static-1.53090",
  "tinymce-copilot": "static-1.16269",
  "xray-recommendation-lib": "static-1.7822",
  "automation-ui-routing": "static-1.20972",
  "sql-reporting-client-types": "static-1.5582",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42037",
  "campaigns-utils-lib": "static-1.3108",
  "reporting-enablement": "static-1.22696",
  "chatspot-widget-iframe": "static-1.20999",
  "collaboration-sidebar-common": "static-1.2418",
  "forms-ai-lib": "static-1.4224",
  "codemirror-dlb": "static-1.58506",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6373",
  "report-customization-components": "static-1.12974",
  "data-quality-ui-library": "static-1.12728",
  "html-to-image": "static-1.52",
  "reporting-filters": "static-1.162",
  "reporting-insights-lib": "static-1.1560"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12059",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.459",
  "dashboard-client-types": "/dashboard-client-types/static-1.339",
  "data-fetching-client": "/data-fetching-client/static-1.9618",
  "foundations-components": "/foundations-components/static-1.7815",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.840",
  "foundations-theming": "/foundations-theming/static-1.4359",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.80",
  "head-dlb": "/head-dlb/static-1.4938",
  "hs-test-utils": "/hs-test-utils/static-1.7960",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9828",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyleTokens": "/HubStyleTokens/static-2.11404",
  "I18n": "/I18n/static-7.1610",
  "jasmine-runner": "/jasmine-runner/static-1.6414",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12120",
  "quartz": "/quartz/static-1.6944",
  "react-dlb": "/react-dlb/static-1.77",
  "react-rhumb": "/react-rhumb/static-1.16607",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2804",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9195",
  "settings-ui-lib": "/settings-ui-lib/static-1.12466",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7025",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11095",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9490",
  "unified-auth": "/unified-auth/static-1.416",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.697",
  "usage-tracker": "/usage-tracker/static-1.7281",
  "usage-tracker-core": "/usage-tracker-core/static-1.7131",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8028",
  "hub-http": "/hub-http/static-1.6165",
  "integrations-lib": "/integrations-lib/static-1.15929",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19488",
  "property-management-iframe": "/property-management-iframe/static-1.12965",
  "quartz-config": "/quartz-config/static-1.722",
  "quartz-core": "/quartz-core/static-1.6163",
  "quartz-routing": "/quartz-routing/static-1.374",
  "quick-fetch": "/quick-fetch/static-1.3870",
  "react": "/react/static-7.184",
  "rpc-client-utils": "/rpc-client-utils/static-1.4591",
  "ts-schema": "/ts-schema/static-1.4031",
  "ui-universal-auth": "/ui-universal-auth/static-1.8902",
  "UIComponents": "/UIComponents/static-3.8351",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.428",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "raven": "/raven/static-3.5829",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.77",
  "metrics-js": "/metrics-js/static-1.9542",
  "react-redux": "/react-redux/static-7.70",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.88",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3357",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3221",
  "quartz-webpack": "/quartz-webpack/static-1.3168",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.22",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4084",
  "floating-ui": "/floating-ui/static-1.54",
  "foundations-assets": "/foundations-assets/static-1.4797",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2075",
  "framer-motion": "/framer-motion/static-1.70",
  "hs-story-utils": "/hs-story-utils/static-1.9373",
  "react-aria": "/react-aria/static-1.64",
  "react-create-root-preference": "/react-create-root-preference/static-1.9",
  "react-select-plus": "/react-select-plus/static-1.103",
  "react-utils": "/react-utils/static-2.5297",
  "react-virtualized": "/react-virtualized/static-2.97",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "tanstack-table": "/tanstack-table/static-1.53",
  "trellis-assets": "/trellis-assets/static-1.1636",
  "ui-fonts": "/ui-fonts/static-1.666",
  "ui-images": "/ui-images/static-2.1138",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2842",
  "foundations-theming-base": "/foundations-theming-base/static-1.3344",
  "stylex": "/stylex/static-1.31",
  "HeadJS": "/HeadJS/static-2.740",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3071",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.81",
  "jasmine": "/jasmine/static-4.4269",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8785",
  "ai-rendering-library": "/ai-rendering-library/static-1.9884",
  "chirp-fetch": "/chirp-fetch/static-1.1830",
  "connections-embed-lib": "/connections-embed-lib/static-1.890",
  "copilot-toolkit": "/copilot-toolkit/static-1.10962",
  "feedback-loader": "/feedback-loader/static-1.29191",
  "laboratory-lib": "/laboratory-lib/static-3.7103",
  "marketplace-embed": "/marketplace-embed/static-1.21910",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9384",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19444",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13659",
  "sanitize-text": "/sanitize-text/static-1.8087",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8642",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5695",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4967",
  "wootric-nps": "/wootric-nps/static-1.6927",
  "quartz-head": "/quartz-head/static-1.609",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4593",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4098",
  "highcharts": "/highcharts/static-8.102",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2458",
  "reporting-data": "/reporting-data/static-1.67262",
  "cssUtils": "/cssUtils/static-1.778",
  "flux-actions": "/flux-actions/static-1.329",
  "HubStyle": "/HubStyle/static-2.11712",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10155",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10316",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7271",
  "icons": "/icons/static-2.643",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18021",
  "storybook-react": "/storybook-react/static-1.31",
  "trellis-story-utils": "/trellis-story-utils/static-1.4460",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5298",
  "quartz-i18n": "/quartz-i18n/static-1.619",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.65",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.172",
  "fsm": "/fsm/static-1.3677",
  "customer-data-objects": "/customer-data-objects/static-1.7605",
  "property-translator": "/property-translator/static-1.5347",
  "hs-locale-management": "/hs-locale-management/static-1.37",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7871",
  "hs-promise-utils": "/hs-promise-utils/static-1.5538",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4821",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13344",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5541",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7728",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4417",
  "superstore": "/superstore/static-1.4711",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10093",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7790",
  "hub-http-janus": "/hub-http-janus/static-1.826",
  "hubspotter-http": "/hubspotter-http/static-1.4605",
  "immutable-less": "/immutable-less/static-1.4594",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16895",
  "nav-meta": "/nav-meta/static-1.29459",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10190",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17902",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3794",
  "property-management-common": "/property-management-common/static-1.5253",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8997",
  "dispatcher": "/dispatcher/static-1.135",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.514",
  "module-federation": "/module-federation/static-1.21",
  "quartz-auth": "/quartz-auth/static-1.619",
  "quartz-test": "/quartz-test/static-1.619",
  "quartz-tracking": "/quartz-tracking/static-1.323",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.3123",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21008",
  "ContentUtils": "/ContentUtils/static-1.68187",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12967",
  "sassPrefix": "/sassPrefix/static-1.154",
  "avatar-components": "/avatar-components/static-1.2440",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39546",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13100",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14129",
  "ExportDialog": "/ExportDialog/static-6.10337",
  "highlight.js": "/highlight.js/static-1.77",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.41139",
  "reporting-snowflake": "/reporting-snowflake/static-1.55880",
  "reporting-ui-components": "/reporting-ui-components/static-2.64533",
  "reporting-visualizations": "/reporting-visualizations/static-1.59338",
  "ui-addon-teams": "/ui-addon-teams/static-1.21471",
  "magpie-lib": "/magpie-lib/static-1.5523",
  "navigation-components": "/navigation-components/static-1.17822",
  "magpie-types": "/magpie-types/static-1.4983",
  "simple-logging-lib": "/simple-logging-lib/static-1.2993",
  "ai-studio-lib": "/ai-studio-lib/static-1.11428",
  "app-governance-lib": "/app-governance-lib/static-1.1358",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10452",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7939",
  "ui-product-approvals": "/ui-product-approvals/static-1.27973",
  "ui-tool-access": "/ui-tool-access/static-1.10093",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8578",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5698",
  "usage-tracker-public": "/usage-tracker-public/static-1.7092",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3544",
  "persist-promise": "/persist-promise/static-1.3652",
  "reference-resolvers": "/reference-resolvers/static-1.8114",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3875",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.280",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2956",
  "final-form": "/final-form/static-1.68",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2608",
  "merchandise-lib": "/merchandise-lib/static-1.262",
  "atom": "/atom/static-1.5016",
  "purchase-motions-components": "/purchase-motions-components/static-1.5778",
  "salesImages": "/salesImages/static-1.524",
  "batch-promise": "/batch-promise/static-1.1495",
  "crm-component-utils": "/crm-component-utils/static-1.38924",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5820",
  "customer-data-properties": "/customer-data-properties/static-1.51345",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6822",
  "property-value-citations": "/property-value-citations/static-1.1959",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8038",
  "navigation-messaging": "/navigation-messaging/static-1.7149",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9826",
  "cms-field-types": "/cms-field-types/static-1.4755",
  "content-icons-ui": "/content-icons-ui/static-1.2211",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9770",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7193",
  "crm-message-bus": "/crm-message-bus/static-1.42828",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21981",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4664",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3963",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6727",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.923",
  "onboarding-tours": "/onboarding-tours/static-1.16485",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13499",
  "academy-common-lib": "/academy-common-lib/static-1.13589",
  "content-assistance-lib": "/content-assistance-lib/static-1.7661",
  "dashboard-lib": "/dashboard-lib/static-1.81291",
  "file-manager-components": "/file-manager-components/static-1.23451",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18336",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18065",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18057",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19727",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8641",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4714",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10946",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8990",
  "user-context": "/user-context/static-1.5045",
  "growth-payments-core": "/growth-payments-core/static-1.25197",
  "reporting-plugins": "/reporting-plugins/static-1.10196",
  "reporting-reports": "/reporting-reports/static-1.66940",
  "idb-keyval": "/idb-keyval/static-1.42",
  "reactive-lib": "/reactive-lib/static-1.665",
  "nest": "/nest/static-1.168",
  "codemirror": "/codemirror/static-5.93",
  "react-codemirror": "/react-codemirror/static-1.10568",
  "framework-listing-lib": "/framework-listing-lib/static-2.28514",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30560",
  "apps-service-types": "/apps-service-types/static-1.3821",
  "oauth-service-types": "/oauth-service-types/static-1.4193",
  "onboarding-scopes": "/onboarding-scopes/static-1.6407",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4699",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7625",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14830",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3564",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9070",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.5781",
  "signup-constants": "/signup-constants/static-1.18737",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7981",
  "trials-service-types": "/trials-service-types/static-1.3847",
  "card-properties-lib": "/card-properties-lib/static-1.43998",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36936",
  "crm-actions": "/crm-actions/static-1.6261",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43407",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9155",
  "customer-data-tracking": "/customer-data-tracking/static-1.6830",
  "hs-resources": "/hs-resources/static-1.86",
  "pulse": "/pulse/static-1.497",
  "calling-global-api": "/calling-global-api/static-1.64304",
  "calling-internal-common": "/calling-internal-common/static-1.31245",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65686",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57980",
  "commerce-products-lib": "/commerce-products-lib/static-1.9310",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3750",
  "crm-links": "/crm-links/static-1.6223",
  "external-options-client-types": "/external-options-client-types/static-1.4112",
  "google-libphonenumber": "/google-libphonenumber/static-1.36",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4177",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.575",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3645",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48543",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3919",
  "smart-property-lib": "/smart-property-lib/static-1.6651",
  "tiered-pricing": "/tiered-pricing/static-1.1083",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10933",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4096",
  "react-dnd-compat": "/react-dnd-compat/static-1.4564",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5334",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3012",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1745",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.551",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7474",
  "academy-service-client": "/academy-service-client/static-1.3626",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.38950",
  "FileManagerLib": "/FileManagerLib/static-1.39091",
  "zustand": "/zustand/static-1.72",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28381",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8319",
  "video-components-external": "/video-components-external/static-1.11081",
  "video-data-lib": "/video-data-lib/static-1.34739",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8479",
  "payment-link-components": "/payment-link-components/static-1.23367",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9832",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24246",
  "viral-links-lib": "/viral-links-lib/static-1.6996",
  "data-token-picker": "/data-token-picker/static-1.16299",
  "react-flip-move": "/react-flip-move/static-1.68",
  "nested-table": "/nested-table/static-1.170",
  "timezone-utils": "/timezone-utils/static-2.5188",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17454",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8901",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-associations": "/customer-data-associations/static-1.7270",
  "customer-data-views-management": "/customer-data-views-management/static-1.25336",
  "framework-data-table": "/framework-data-table/static-2.11783",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6795",
  "nudge-client-utils": "/nudge-client-utils/static-1.2430",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.910",
  "app-users-service-client": "/app-users-service-client/static-1.5528",
  "app-users-service-types": "/app-users-service-types/static-1.4936",
  "mini-checkout-client": "/mini-checkout-client/static-1.26655",
  "onboarding-utils": "/onboarding-utils/static-1.5295",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2018",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28366",
  "edison-service-client-types": "/edison-service-client-types/static-1.330",
  "crm_data": "/crm_data/static-4.91768",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45835",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15769",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18895",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18355",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10217",
  "crm-fe-perf": "/crm-fe-perf/static-1.22848",
  "directed-graph": "/directed-graph/static-1.880",
  "event-emitter": "/event-emitter/static-1.893",
  "fast-json-patch": "/fast-json-patch/static-1.61",
  "calling-error-reporting": "/calling-error-reporting/static-1.31251",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10981",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6486",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.749",
  "commerce-permissions": "/commerce-permissions/static-1.709",
  "products-iframe-lib": "/products-iframe-lib/static-1.7759",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10210",
  "data-agent-kit": "/data-agent-kit/static-1.101",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9911",
  "policy-lib": "/policy-lib/static-1.6716",
  "react-tinymce": "/react-tinymce/static-1.55075",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9974",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54201",
  "tinymce-plugins": "/tinymce-plugins/static-1.57315",
  "tinymce-themes": "/tinymce-themes/static-1.56171",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1859",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1773",
  "user-context-client": "/user-context-client/static-1.4554",
  "audio-components": "/audio-components/static-1.5826",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.36602",
  "urlinator": "/urlinator/static-1.4476",
  "video-components": "/video-components/static-1.13084",
  "video-embed": "/video-embed/static-1.35573",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6528",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12055",
  "content-media-compositions": "/content-media-compositions/static-2.16062",
  "media-bridge-lib": "/media-bridge-lib/static-1.18823",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5985",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5026",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3583",
  "draft-convert": "/draft-convert/static-2.71",
  "draft-extend": "/draft-extend/static-3.73",
  "draft-js": "/draft-js/static-5.76",
  "draft-plugins": "/draft-plugins/static-2.21567",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3786",
  "ts-utils-lib": "/ts-utils-lib/static-1.116",
  "crm-export-dialog": "/crm-export-dialog/static-1.6242",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6383",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1807",
  "tanstack-virtual": "/tanstack-virtual/static-1.28",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2187",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2506",
  "whisper-core-api": "/whisper-core-api/static-1.6439",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14638",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5372",
  "settings-content-modals": "/settings-content-modals/static-1.45910",
  "crm_universal": "/crm_universal/static-1.21902",
  "customer-data-email": "/customer-data-email/static-1.17929",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36999",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39359",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11807",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54518",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21294",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17594",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71780",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5280",
  "utility-belt": "/utility-belt/static-1.2482",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22488",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7397",
  "customer-data-rte": "/customer-data-rte/static-1.32840",
  "cv-backend-services": "/cv-backend-services/static-1.1551",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5608",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5054",
  "qrcode-generator": "/qrcode-generator/static-1.67",
  "quotes-client-types": "/quotes-client-types/static-1.37870",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35526",
  "sales-views-client-types": "/sales-views-client-types/static-1.4208",
  "hub-http-contrib": "/hub-http-contrib/static-1.2984",
  "interframe": "/interframe/static-3.4705",
  "tinymce-data": "/tinymce-data/static-1.40286",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5154",
  "layout-dnd-components": "/layout-dnd-components/static-1.12329",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11304",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14977",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9016",
  "social-insights-client-types": "/social-insights-client-types/static-1.21921",
  "outpost": "/outpost/static-1.4134",
  "js-cookie": "/js-cookie/static-1.18",
  "deal-intel-utils": "/deal-intel-utils/static-1.1811",
  "checkout-sdk": "/checkout-sdk/static-3.23498",
  "checkout-service-types": "/checkout-service-types/static-1.3780",
  "company-details-components": "/company-details-components/static-1.6140",
  "payment-method-components": "/payment-method-components/static-1.6854",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.13578",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3422",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3468",
  "access-control-lib": "/access-control-lib/static-1.10382",
  "EmailComponents": "/EmailComponents/static-1.54603",
  "EmailData": "/EmailData/static-1.53280",
  "redux-less": "/redux-less/static-2.9428",
  "sequences-lib": "/sequences-lib/static-1.7937",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10290",
  "products-ui-components": "/products-ui-components/static-1.39829",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80501",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6966",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54534",
  "commerce-products-api": "/commerce-products-api/static-1.2202",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56592",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102458",
  "stripe-connect-js": "/stripe-connect-js/static-1.67",
  "draft-content-plugins": "/draft-content-plugins/static-1.28108",
  "ContentData": "/ContentData/static-1.68262",
  "layout-data-lib": "/layout-data-lib/static-1.9629",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.792",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3876",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.3934",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.502",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18484",
  "pricing-pages-api": "/pricing-pages-api/static-1.13443",
  "ContentComponents": "/ContentComponents/static-2.71143",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.9746",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1877",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46090",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.952",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.18697",
  "automation-ui-types": "/automation-ui-types/static-1.19615",
  "messaging-types-lib": "/messaging-types-lib/static-1.45827",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4446",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7794",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.466",
  "property-description-translator": "/property-description-translator/static-1.3792",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9156",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3571",
  "totals-ui-components": "/totals-ui-components/static-1.23417",
  "advanced-menus-core": "/advanced-menus-core/static-1.15035",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11989",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33886",
  "segments-query-core": "/segments-query-core/static-1.1358",
  "demographics-service-types": "/demographics-service-types/static-1.1596",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3128",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5531",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7284",
  "data-token-views": "/data-token-views/static-1.16280",
  "forms-utils-lib": "/forms-utils-lib/static-1.12467",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.12909",
  "simple-menus-core": "/simple-menus-core/static-1.15034",
  "simple-menus-lib": "/simple-menus-lib/static-1.16551",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4199",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6734",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3457",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2562",
  "ContentEditorUI": "/ContentEditorUI/static-2.76947",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3924",
  "web-interactives-components": "/web-interactives-components/static-1.13657",
  "web-interactives-data": "/web-interactives-data/static-1.13658",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.401",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.571",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.920",
  "FireAlarmUi": "/FireAlarmUi/static-1.4467",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4121",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3772",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21551",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21014",
  "data-studio-ubb": "/data-studio-ubb/static-1.2543",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.26857",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57621",
  "content-management-data-lib": "/content-management-data-lib/static-1.5309",
  "copilot-plugins": "/copilot-plugins/static-1.10935",
  "cta-picker": "/cta-picker/static-1.36244",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.2913",
  "editor-components": "/editor-components/static-1.13149",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8320",
  "error-messaging-js": "/error-messaging-js/static-1.5136",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85677",
  "pictos": "/pictos/static-7.183",
  "react-transition-group": "/react-transition-group/static-2.63",
  "redux-request-state": "/redux-request-state/static-1.10591",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1689",
  "smart-content-core": "/smart-content-core/static-1.42273",
  "smart-content-lib": "/smart-content-lib/static-1.42926",
  "social-composer-lib": "/social-composer-lib/static-1.58834",
  "structured-content-lib": "/structured-content-lib/static-1.25032",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53090",
  "tinymce-copilot": "/tinymce-copilot/static-1.16269",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7822",
  "automation-ui-routing": "/automation-ui-routing/static-1.20972",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5582",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42037",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3108",
  "reporting-enablement": "/reporting-enablement/static-1.22696",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.20999",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2418",
  "forms-ai-lib": "/forms-ai-lib/static-1.4224",
  "codemirror-dlb": "/codemirror-dlb/static-1.58506",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6373",
  "report-customization-components": "/report-customization-components/static-1.12974",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12728",
  "html-to-image": "/html-to-image/static-1.52",
  "reporting-filters": "/reporting-filters/static-1.162",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1560"
}
};
